module.exports = __webpack_public_path__ + "static/privileged-compare-89f3f54bd671dea078881f97ce0ab5ce.png";